import styled from 'styled-components';
var LogoHeader = styled.div.withConfig({
  displayName: "FulfilledByArgosstyles__LogoHeader",
  componentId: "sc-33wgd5-0"
})(["text-align:center;padding-top:10px;padding-bottom:20px;border-bottom:1px solid ", ";svg{margin:0 10px;}"], function (props) {
  return props.theme.color.monochrome.light;
});
var ContentBody = styled.div.withConfig({
  displayName: "FulfilledByArgosstyles__ContentBody",
  componentId: "sc-33wgd5-1"
})(["ul{list-style:initial;margin-left:17px;}div{margin-top:25px;}"]);
export { LogoHeader, ContentBody };